import { render, staticRenderFns } from "./TheAdminCustomReportConfig.vue?vue&type=template&id=0a855518&scoped=true&"
import script from "./TheAdminCustomReportConfig.vue?vue&type=script&lang=js&"
export * from "./TheAdminCustomReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./TheAdminCustomReportConfig.vue?vue&type=style&index=0&id=0a855518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a855518",
  null
  
)

export default component.exports